var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 8 13" }, props),
    React.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M7.9 6.5c0-.4-.1-.7-.4-1l-5-5c-.6-.6-1.4-.6-2 0s-.6 1.4 0 2l4 4-4 4c-.6.6-.6 1.4 0 2s1.4.6 2 0l5-5c.3-.3.4-.6.4-1z" })
  );
});


// WEBPACK FOOTER //
// ./icons/images/indicators/CaretRight.svg